import type { IconData } from '@stacksjs/iconify-core'

export const magnet: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M26.08 4.15c-.735-.752-1.846-.932-2.817-.527C20.134 4.93 17.15 6.59 14.352 8.49C3.04 16.163-1.666 28.639 8.935 39.337c10.257 10.352 23.34 5.3 30.58-5.416c1.906-2.822 3.598-5.885 4.899-9.072c.384-.94.218-2.01-.509-2.718c-1.358-1.324-3.943-3.368-7.547-4.134c-1.109-.236-2.198.349-2.789 1.316c-1.116 1.827-2.96 4.812-4.165 6.595c-3.537 5.235-8.413 7.463-11.485 4.363c-3.073-3.101-1.121-8.031 4.244-11.671c1.84-1.248 4.988-3.132 6.804-4.204c.875-.517 1.47-1.442 1.337-2.45c-.452-3.443-2.756-6.292-4.224-7.795\" clip-rule=\"evenodd\"/><path d=\"M41.422 30.888c-2.7-1.21-7.137-3.489-10.842-6.777m-6.518-6.742c-3.132-3.844-5.279-8.34-6.383-10.97\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default magnet
